const ApiEnvironment = {
  Type: {
    local: 'local',
    test: 'test',
    localTest: 'localTest',
    Release: 'release',
  },
  Services: {
    userService: 'userService',
  },
};

export default ApiEnvironment;
